import React from 'react'
import HomeView from './Home';

const HomeViewDisplay = () => {
    return (
        <>
            <HomeView />
        </>
    )
}

export default HomeViewDisplay;